import { render, staticRenderFns } from "./LangSwitch.vue?vue&type=template&id=60dae6f5&scoped=true"
import script from "./LangSwitch.vue?vue&type=script&lang=js"
export * from "./LangSwitch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60dae6f5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/print-suite/source/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60dae6f5')) {
      api.createRecord('60dae6f5', component.options)
    } else {
      api.reload('60dae6f5', component.options)
    }
    module.hot.accept("./LangSwitch.vue?vue&type=template&id=60dae6f5&scoped=true", function () {
      api.rerender('60dae6f5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/utility/LangSwitch.vue"
export default component.exports